import Row from 'Components/Base/Row'
import Template2 from 'Pages/CTLChallenges/Components/Templates/Template2'
import React, { useEffect, useState } from 'react'
import data from 'tria-ui-react-lib/challenges/stepInfo.json'
import { Paragraph, SectionInfo } from 'types/Challenge'

interface Props {
  step: number
  setInfoPage: (infoPage: boolean) => void
}
export default function WeightLossStep3({ step, setInfoPage }: Props) {
  const [sectionInfo, setSectionInfo] = useState<SectionInfo>()
  const [stepParagraphs, setStepParagraphs] = useState<Paragraph[]>()
  const [isMobile, setIsMobile] = useState<boolean>()

  useEffect(() => {
    window.scrollTo(0, 0)
    setInfoPage(true)
    setSectionInfo(
      data.pageInfoBySection.sectionInfo.find(
        (sectionInfo) => sectionInfo.sectionId === parseInt(window.location.pathname.split('/')[window.location.pathname.split('/').length - 2]),
      ),
    )
    setStepParagraphs(
      data.pageInfoBySection.sectionInfo.find(
        (sectionInfo) => sectionInfo.sectionId === parseInt(window.location.pathname.split('/')[window.location.pathname.split('/').length - 2]),
      )?.paragraphs,
    )
    window.addEventListener('resize', () => {
      if (window.innerWidth < 1200) {
        setIsMobile(true)
      } else {
        setIsMobile(false)
      }
    })

    if (window.innerWidth < 1200) {
      setIsMobile(true)
    } else {
      setIsMobile(false)
    }
  }, [step])

  return (
    //going to need paragraph "Aerobic Activity" capitalized
    <Template2
      isMobile={isMobile}
      title={sectionInfo?.titles.find((title) => title.titleId === 2)?.titleText ?? ''}
      textSection={
        <>
          <Row styles={{ margin: isMobile ? '20px auto' : '20px 0px' }}>
            <p style={{ fontFamily: 'Raleway', fontSize: 20 }}>{stepParagraphs?.find((paragraph) => paragraph.paragraphId === 6)?.paragraph ?? ''}</p>
          </Row>
          <Row styles={{ margin: isMobile ? '20px auto' : '20px 0px' }}>
            <p style={{ fontFamily: 'Raleway', fontSize: 20 }}>
              <b>{stepParagraphs?.find((paragraph) => paragraph.paragraphId === 35)?.paragraph ?? ''}: </b>
              {stepParagraphs?.find((paragraph) => paragraph.paragraphId === 7)?.paragraph ?? ''}
            </p>
          </Row>
          <Row styles={{ margin: isMobile ? '20px auto' : '20px 0px' }}>
            <p style={{ fontFamily: 'Raleway', fontSize: 20 }}>{stepParagraphs?.find((paragraph) => paragraph.paragraphId === 8)?.paragraph ?? ''}</p>
          </Row>
        </>
      }
      imgSrc={sectionInfo?.images.find((image) => image.imageId === 3)?.url ?? ''}
    />
  )
}
